import { useDispatch, useSelector } from 'react-redux';
import { updateViewRequest } from 'modules/messagingInsights/actions';
import { useViewContext } from 'modules/messagingInsights/context';
import { selectSavedView } from 'modules/messagingInsights/selectors';
import { BoldSpan } from 'modules/messagingInsights/Styled';
import { BUTTON_SIZES, PrimaryButton } from 'ui/button';
import { MODAL_SIZES, MODAL_VARIANTS, Modal, ModalFooter, ModalBody, ModalHeader } from 'ui/modal';
import { useViewsModals } from '../hooks/useViewsModals';

export const SetDefaultModal = () => {
  const dispatch = useDispatch();

  const { setDefault: setDefaultModal } = useViewsModals();
  const view = useSelector(selectSavedView) || {};
  const { toggleRefetchDropdownViews } = useViewContext();

  const handleClose = () => setDefaultModal.toggle(false);

  const callback = () => {
    toggleRefetchDropdownViews();
  };

  const handleSave = () => {
    dispatch(updateViewRequest({ ...view, isProjectDefault: true }, callback));
    handleClose();
  };

  return (
    <Modal
      id="set-as-default-modal"
      isModalOpen={true}
      onClose={handleClose}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
    >
      <ModalHeader>Set as default saved view?</ModalHeader>
      <ModalBody>
        Are you sure you want to set <BoldSpan>{view.name}</BoldSpan> as the default saved view for{' '}
        <BoldSpan>everyone in this project</BoldSpan>?
      </ModalBody>
      <ModalFooter>
        <PrimaryButton onClick={handleSave} size={BUTTON_SIZES.LARGE}>
          Set as default
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  );
};
